
<template>

    <a data-toggle="popover" data-placement="top" data-trigger="hover" v-bind:class="{'faa-flash animated': showChangedRecently > 0}">
        <span v-if="scheduledRound" v-bind:style="{ opacity : (status==0 ? '0.3' : '1')}">
            <span class="fa-stack fa-2x " style="margin:-10px"
                  v-bind:class="{'text-muted' : status==0, 'text-success':status==15, 'text-warning' : status==25, 'text-warning': status==35, 'text-danger'  : status == 40}">
                <i class="fa fa-stack-1x" v-bind:class="{'fa-circle-o text-muted' : status==0, 'fa-check text-success':status==15, 'fa-repeat text-warning' : status==25, 'fa-clock-o text-warning': status==35, 'fa-exclamation-triangle text-danger'  : status == 40}"></i>
                <strong style="margin-left:38px; margin-top:6px;width:auto;"> <small style="font-size:12px;opacity: 0.5;">{{primaryCount}}</small></strong>
            </span>

            <span v-for="item in secondaryItems" style="margin-left:3px"
                  class="fa-stack fa-1x "
                  v-bind:class="{'text-muted' : item.status==0, 'text-success':item.status==15, 'text-warning' : item.status==25, 'text-warning': item.status==35, 'text-danger'  : item.status == 40}">
                <i class="fa fa-stack-1x" v-bind:class="{'fa-circle-o text-muted' : item.status==0, 'fa-check text-success':item.status==15, 'fa-repeat text-warning' : item.status==25, 'fa-clock-o text-warning': item.status==35, 'fa-exclamation-triangle text-danger'  : item.status == 40}"></i>
                <small style="font-size:10px;opacity: 0.8;"><strong class="fa-stack-1x" style="margin-left:15px; margin-top:6px; margin-right:0px;margin-bottom:0px;width:auto;">{{item.count}}</strong></small>
            </span>
        </span>
        <span v-else>

            <span v-show="primaryCount > 0" class="fa-stack fa-1x" v-bind:class="{'text-muted' : status==0, 'text-success':status==15, 'text-warning' : status==25, 'text-warning': status==35, 'text-danger'  : status == 40}">
                <i class="fa fa-circle-o fa-stack-2x"></i>
                <span class="fa-stack-1x">
                    <small><strong class="text-primary">{{this.group.medRoundGroupName.charAt(0)}}</strong></small>
                    <!--<small style="margin-left:15px;margin-top:10px;font-size:12px;opacity: 0.5;">{{primaryCount}}</small>-->

                </span>
            </span>

            <i v-show="!primaryCount || primaryCount <= 0" class="fa fa-2x fa-circle-o text-muted" v-bind:style="{ opacity : (this.group.medRoundGroupStatus == 0 ? '0.3' : '1')}"></i>
        </span>
    </a>
</template>
<script>
    import $ from 'jquery'
    import { MedRoundGroup } from '../../../dto/Dtos';
    export default {
        props: ['group', 'warfarinStatus', 'changedRecently'],
        data: function () {
            return {
                showChangedRecently: 0,
                showDetail: false,
                status: 0,
                primaryCount: null,
                scheduledRound: true,
                secondaryItems: [],
            }
        },
        watch: {
            changedRecently() {
                if (this.changedRecently) {
                    this.showChangedRecently += 1;
                    var that = this;
                    setTimeout(() => {
                        that.showChangedRecently -= 1;
                    }, 10 * 1000);
                }
            },
            group: function () {
                this.updateStatus();
            }
        },
        mounted: function () {
            //console.log("Round : ",this.round);
            var resultCountries = ['Germany', 'France', 'Spain'];
            var that = this;
            $(this.$el).popover({
                html: true,
                trigger: 'hover',
                title: function () {
                    if (that.group.medRoundGroupStatus == 0) {
                        return 'No Meds'
                    }
                    else if (that.group.medRoundGroupStatus == 15) {
                        return 'All Meds Taken'
                    }
                    else if (that.group.medRoundGroupStatus == 25) {
                        return 'Skipped'
                    }
                    else if (that.group.medRoundGroupStatus == 35) {
                        return 'Pending'
                    }
                    return 'Missed';
                },
                content: function () {
                    var result = $();
                    if (that.group.missedCount && that.group.missedCount > 0) {
                        result = result.add(('<span> Missed : ' + that.group.missedCount + '<span/><br/>'));
                    }
                    if (that.group.skipCount && that.group.skipCount > 0) {
                        result = result.add(('<span> Skipped : ' + that.group.skipCount + '<span/><br/>'));
                    }
                    if (that.group.pendingCount && that.group.pendingCount > 0) {
                        result = result.add(('<span> Pending : ' + that.group.pendingCount + '<span/><br/>'));
                    }
                    if (that.group.takenCount && that.group.takenCount > 0) {
                        result = result.add(('<span> Taken : ' + that.group.takenCount + '<span/><br/>'));
                    }
                    //for (var i in resultCountries) {
                    //    result = result.add(('<span>' + i + ' &ndash; ' + resultCountries[i] + '<span/><br/>'));
                    //    console.log(i, resultCountries[i]);
                    //}
                    return result;
                }
            })
            this.updateStatus()
        },
        methods: {
            updateStatus: function () {
                if (!this.group)
                    return;

                var statusCount = this.group.takenCount > 0 ? 1 : 0;
                statusCount += this.group.skipCount > 0 ? 1 : 0;
                statusCount += this.group.pendingCount > 0 ? 1 : 0;
                statusCount += this.group.missedCount > 0 ? 1 : 0;
                this.showDetail = statusCount > 1;
                this.status = this.group.medRoundGroupStatus;
                this.primaryCount =
                    this.group.missedCount && this.group.missedCount > 0 ? this.group.missedCount :
                        (this.group.skipCount && this.group.skipCount > 0 ? this.group.skipCount :
                        (this.group.pendingCount && this.group.pendingCount > 0 ? this.group.pendingCount : 
                            (this.group.takenCount && this.group.takenCount > 0 ? this.group.takenCount :null)));
                this.secondaryItems = [];
                if (this.showDetail) {
                    //if (!(this.group.missedCount && this.group.missedCount > 0)) {
                    //    this.secondaryItems.push({ status: 40, count: this.group.missedCount });
                    //}
                    if (this.group.skipCount && this.group.skipCount > 0 && this.group.medRoundGroupStatus != 25) {
                        this.secondaryItems.push({ status: 25, count: this.group.skipCount });
                    }
                    if (this.group.pendingCount && this.group.pendingCount > 0 && this.group.medRoundGroupStatus != 35) {
                        this.secondaryItems.push({ status: 35, count: this.group.pendingCount });
                    }
                    if (this.group.takenCount && this.group.takenCount > 0 && this.group.medRoundGroupStatus != 15) {
                        this.secondaryItems.push({ status: 15, count: this.group.takenCount });
                    }
                }
                //console.log(this.group)
                if (
                    this.group.medRoundGroupName.toUpperCase() == "INSULIN"
                    || this.group.medRoundGroupName.toUpperCase() == "WARFARIN"
                    || this.group.medRoundGroupName.toUpperCase() == "PRN") {
                    this.scheduledRound = false;
                }
            },
            statusIconStyle: function (status) {
                if (status == 0) {
                    return 'fa-circle-o text-muted'
                }
                else if (status == 15) {
                    return 'fa-check text-success'
                }
                else if (status == 25) {
                    return 'fa-repeat text-warning'
                }
                else if (status == 35) {
                    return 'fa-clock-o text-warning'
                }
                return 'fa-exclamation-triangle text-danger'
            },
            statusText: function (status) {
                if (status == 0) {
                    return 'No Meds'
                }
                else if (status == 15) {
                    return 'All Meds Taken'
                }
                else if (status == 25) {
                    return 'Skipped'
                }
                else if (status == 35) {
                    return 'Pending'
                }
                return 'Missed';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// dispensationStatusIcons.scp.html?3711fa0d